import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/i18nContext';
import { useTheme } from '../context/ThemeContext';
import '../styles/Auth.css';

const AuthCallback = () => {
  // ============================================
  // HOOKS
  // ============================================
  const { t, setLanguage } = useI18n();
  const { applyServerTheme } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { api } = useAuth();  // Axios instance a user lekérdezéshez

  // ============================================
  // STATE
  // ============================================
  const [error, setError] = useState(null);

  // ============================================
  // EFFECT: SSO Callback Feldolgozása
  // ============================================
  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // LÉPÉS 1: URL paraméterek parse-olása
        const accessToken = searchParams.get('accessToken');
        const refreshToken = searchParams.get('refreshToken');
        const userId = searchParams.get('userId');
        const isNew = searchParams.get('isNew') === 'true';

        // LÉPÉS 2: Paraméterek ellenőrzése
        if (!accessToken || !refreshToken) {
          // Nincsenek tokenek az URL-ben
          // Valami hiba történt az OAuth-ban
          setError(t('auth.errors.loginFailed'));
          
          // 3 másodperc után átirányítunk a login-hez
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          return;
        }

        // LÉPÉS 3: Tokenek mentése a localStorage-be
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);

        // LÉPÉS 4: Axios default header frissítése
        // (hogy a következő API kérések már az új token-nel menjenek)
        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

        // LÉPÉS 5: User adatainak lekérdezése
        const response = await api.get('/auth/me');
        const user = response.data.user;

        // LÉPÉS 6: Nyelv és téma alkalmazása
        if (user?.preferred_language) setLanguage(user.preferred_language);
        if (user?.preferred_theme) applyServerTheme(user.preferred_theme);

        // LÉPÉS 6: AuthContext Update lenne ideális
        // De mivel nem tudjuk direkt beállítani a user-t (context-en kívül vagyunk)
        // A window.location.href-fel átirányítunk, ami app restart = új user load
        // VAGY: Custom event, de komplikált
        
        // LÉPÉS 7: Navigáció a dashboard-hoz
        // 100ms késleltetés, hogy a localStorage-t biztos feldolgozzák
        setTimeout(() => {
          if (isNew) {
            // Új felhasználó: profile setup oldal (később)
            navigate('/setup-profile');
          } else {
            // Meglévő felhasználó: dashboard
            navigate('/dashboard');
          }
        }, 100);
      } catch (err) {
        // Hiba az OAuth feldolgozásban
        console.error('OAuth callback error:', err);
        setError(t('auth.errors.loginFailed'));
        
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleOAuthCallback();
  }, [searchParams, navigate, t, api, setLanguage, applyServerTheme]);

  // ============================================
  // RENDER
  // ============================================
  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* LOADING STATE */}
        {!error && (
          <>
            <h1>{t('common.loading')}</h1>
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
            <p style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: '20px' }}>
              {t('common.loading')}
            </p>
          </>
        )}

        {/* ERROR STATE */}
        {error && (
          <>
            <h1>{t('common.error')}</h1>
            <div className="error-message" style={{ marginBottom: '20px' }}>
              {error}
            </div>
            <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
              3 másodperc alatt átirányítunk a bejelentkezéshez...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;